export const LIMIT_TAG_LIST_ENTITIES = {
  GROUP: 'group',
  WORKSPACE: 'workspace',
  CHANNEL: 'channel',
  DOMAIN: 'domain'
}
